import {AxiosCall} from '../axios';
import {environment} from '../environment/environment';
import {
  ClinicsForUserData,
  ClinicsForUsersParams,
  Group
} from './service-mappers/ClinicServiceMapper';
import {
  ServiceSuccessResponseType,
  ServiceErrorResponseType
} from './service-mappers/BaseMapper';
import {
  ArrayResponse,
  ClinicBaseParams,
  UserBaseParams
} from './service-mappers/CommonServiceMapper';
import {ArrayRows} from './service-mappers/ClinicServiceMapper';
import {
  ClinicGroupModelMapper,
  ClinicModelMapper,
  UserModelMapper
} from './service-mappers/ModelMapper';
import {_seletedGroupType} from '../store/reducers/ClinicReducer';
import {ORGANIZATION_GROUP_TYPES} from '../constants/Mapping';
import {serializeQueryParams} from './PaymentHistoryService';

export interface Provider {
  id: number;
  name: string;
}

export interface ProviderListResponse {
  rows: Provider[];
  count: number;
}

const allClinics = environment.apiEndPoints.clinics.getAll;

export const getClinicsForUser = async (
  params: ClinicsForUsersParams
): Promise<
  ServiceSuccessResponseType<ArrayResponse<Partial<ClinicsForUserData>>>
> => {
  return AxiosCall.get(
    `/group/${params.groupId}/user/${params.userId}${allClinics}`
  );
};

export const getAllClinics = async (
  clinic_group_id: number | string
): Promise<any> => {
  // TODO: Success Response is different. it could be [] or {data: {rows: [], count: }, ...}
  const groupType = _seletedGroupType();
  if (groupType === ORGANIZATION_GROUP_TYPES.BILLING_GROUP_VALUE) {
    return [];
  }
  return AxiosCall.get(`/clinic-group/${clinic_group_id}/clinic/all`);
};

export const getAllClinicGroups = async (
  search_text: string
): Promise<ServiceSuccessResponseType<ArrayResponse<Group>>> => {
  const params = search_text ? `?search_text=${search_text}` : '';
  return AxiosCall.get(`/clinic-group${params}`);
};

export const getClinicGroupsDetails = async (
  clinic_group_id: number | string
): Promise<ServiceSuccessResponseType<ClinicGroupModelMapper>> => {
  return AxiosCall.get(`/clinic-group/${clinic_group_id}`);
};

export const allUserOfClinicGroup = async (
  group_id: number | string | null,
  search_text = ''
): Promise<ServiceSuccessResponseType<ArrayResponse<ArrayRows>>> => {
  return AxiosCall.get(
    `/group/${group_id}/user/all?search_text=${encodeURIComponent(search_text)}`
  );
};

export const addClinic = async (
  group_id: any,
  org_type_id: any,
  values: any
): Promise<ServiceSuccessResponseType<null>> => {
  const clinicObject: Record<string, any> = {
    name: values.clinic_name ? values.clinic_name : '',
    description: values.description ? values.description : '',
    org_type_id: org_type_id,
    email: values.clinic_email ? values.clinic_email : '',
    phone: values.clinic_phone ? values.clinic_phone : '',
    contact_name: values.primary_contact_name
      ? values.primary_contact_name
      : '',
    contact_phone: values.primary_contact_phone
      ? values.primary_contact_phone
      : '',
    contact_email: values.primary_contact_email
      ? values.primary_contact_email
      : '',
    address: values.address_line ? values.address_line : '',
    address_line_2: values.address_line_2 ? values.address_line_2 : '',
    city: values.city ? values.city : '',
    state: values.state ? values.state : '',
    zip: values.zip_postal_code ? values.zip_postal_code : '',
    country: values.country ? values.country : '',
    clinic_logo_url: values.clinic_logo_url ? values.clinic_logo_url : null,
    emr_provider: values.emr_provider ? values.emr_provider : null,
    // sms_provider_phone: values.sms_provider_phone
    //   ? values.sms_provider_phone
    //   : null,
    // payment_provider: values.payment_provider ? values.payment_provider : null,
    // instamed_details: instamed_details,
    // open_edge_details,
    guarantor_login_note: values.guarantor_login_note,
    clinic_contact_text: values.clinic_contact_text,
    clinic_type: values.clinic_type,
    // receive_payment_notifications: Boolean(
    //   !values.receive_payment_notifications
    // ),
    // payment_receiver_email: values.payment_receiver_email ? values.payment_receiver_email : '',
    // payment_receiver_name: values.payment_receiver_name ?  values.payment_receiver_name : '',
    auto_reply_sms_text: values.auto_reply_sms_text,
    should_forward_sms: Boolean(!values.should_forward_sms),
    forward_sms_phone: values.forward_sms_phone,
    after_hours_enabled: values.after_hours_enabled ? true : false,
    after_hours_start: values.after_hours_start || null,
    after_hours_end: values.after_hours_end || null,
    reports: values.reports,
    email_to_receive_report: values.email_to_receive_report,
    reply_to_email: values.reply_to_email,
    default_patient_email: values.default_patient_email
      ? String(values.default_patient_email).trim()
      : null,
    // short_code: values.short_code,
    billing_phone: values.billing_phone,
    practice_website: values.practice_website,
    convenience_fee: values.convenience_fee,
    cancel_copay_statement: Boolean(!values.cancel_copay_statement),
    send_status_emails: Boolean(!values.send_status_emails),
    clinic_provider_enable: values.clinic_provider_enable ? true : false,
    clinic_provider_npi: values.clinic_provider_npi
      ? values.clinic_provider_npi
      : null,
    ncpdp_provider_id: values.ncpdp_provider_id
      ? String(values.ncpdp_provider_id).trim()
      : null,
    is_patient_review_enabled: values.is_patient_review_enabled ? true : false,
    patient_review_url:
      values.is_patient_review_enabled === true
        ? values.patient_review_url
        : null,
    enable_insurance_reminder: values.enable_insurance_reminder ? true : false,
    insurance_reminder_duration: values.insurance_reminder_duration || null,
    insurance_reminder_duration_units:
      values.insurance_reminder_duration_units || null,
    max_no_of_reminders: values.max_no_of_reminders || null,
    location_number: values.location_number || null,
    insurance_provider: values.insurance_provider || null,
    tickets_report_email: values.tickets_report_email
      ? values.tickets_report_email
      : '',
    prior_auth_notification_emails: values.prior_auth_notification_emails
      ? values.prior_auth_notification_emails
      : '',
    personal_injury_practice: values.personal_injury_practice,
    cpt_code_generation: values.cpt_code_generation,
    enable_appointment_need_attention_emails: Boolean(
      values.enable_appointment_need_attention_emails
    ),
    appointment_need_attention_emails: values.appointment_need_attention_emails
      ? values.appointment_need_attention_emails
      : '',
    enable_appointment_escalation_sms: Boolean(
      values.enable_appointment_escalation_sms
    ),
    appointment_escalation_sms_phones: values.appointment_escalation_sms_phones
      ? values.appointment_escalation_sms_phones
      : '',
    enable_appointment_need_attention_sms: Boolean(
      values.enable_appointment_need_attention_sms
    ),
    appointment_need_attention_sms_phones: values.appointment_need_attention_sms_phones
      ? values.appointment_need_attention_sms_phones
      : '',
    hours_before_appt_edit_allowed:
      values.hours_before_appt_edit_allowed !== undefined &&
      values.hours_before_appt_edit_allowed !== null
        ? Number(values.hours_before_appt_edit_allowed)
        : null,
    hours_before_appt_delete_allowed:
      values.hours_before_appt_delete_allowed !== undefined &&
      values.hours_before_appt_delete_allowed !== null
        ? Number(values.hours_before_appt_delete_allowed)
        : null,
    business_start_time: values.business_start_time
      ? values.business_start_time.format
        ? values.business_start_time.format('HH:mm:ss')
        : values.business_start_time
      : null,
    business_end_time: values.business_end_time
      ? values.business_end_time.format
        ? values.business_end_time.format('HH:mm:ss')
        : values.business_end_time
      : null,
    max_family_slot_gap: values.max_family_slot_gap !== undefined && values.max_family_slot_gap !== null
      ? Number(values.max_family_slot_gap)
      : null,
    recording_disclosure_override:
      values.recording_disclosure_override === true
        ? true
        : values.recording_disclosure_override === false
        ? false
        : null,
    recording_disclosure_text:
      typeof values.recording_disclosure_text === 'string' &&
      values.recording_disclosure_text.trim()
        ? values.recording_disclosure_text.trim()
        : null,
  };
  // don't pass ccm if patient shared is on
  if ('is_ccm_enabled' in values) {
    clinicObject.is_ccm_enabled = Boolean(values.is_ccm_enabled);
  }
  // Conditionally add properties to clinicObject
  if (!values.receive_payment_notifications && values.paymentsEnabled) {
    clinicObject.receive_payment_notifications = Boolean(
      !values.receive_payment_notifications
    );
  }
  if (values.payment_receiver_email && values.paymentsEnabled) {
    clinicObject.payment_receiver_email = values.payment_receiver_email;
  }

  if (values.payment_receiver_name && values.paymentsEnabled) {
    clinicObject.payment_receiver_name = values.payment_receiver_name;
  }
  if ('is_claim_tickets_cpt_codes_enabled' in values) {
    clinicObject.is_claim_tickets_cpt_codes_enabled = Boolean(
      values.is_claim_tickets_cpt_codes_enabled
    );
  }
  return AxiosCall.post(`/clinic-group/${group_id}/clinic`, clinicObject);
};

export const deleteClinic = async (
  group_id: number | string,
  clinic_id: number | string
): Promise<ServiceErrorResponseType> => {
  return AxiosCall.delete(`/clinic-group/${group_id}/clinic/${clinic_id}`);
};

export const advancedEditUpdate = async (
  group_id: number | string,
  clinic_id: number | string,
  values: any,
  numberTypeFields?: any,
  smsProviderPhoneId?: any
): Promise<ServiceErrorResponseType> => {
  const instamed_details = {
    merchant: values.merchant_id ? values.merchant_id : '',
    terminal: values.terminal_id ? values.terminal_id : '',
    store: values.store_id ? values.store_id : '',
    corporate_id: values.corporate_id ? values.corporate_id : '',
    account_id: values.account_id ? values.account_id : ''
  };
  const open_edge_details = {
    web_id: values.web_id,
    tid: values.t_id,
    auth_key: values.api_id,
    card_machine_auth_key: values.card_machine_api_id,
    card_machine_tid: values.card_machine_tid
  };

  const clinicObject = {
    statement_alias: values.statement_alias,
    sms_provider_phone: values.sms_provider_phone
      ? values.sms_provider_phone
      : null,
    payment_provider: values.payment_provider ? values.payment_provider : null,
    instamed_details: instamed_details,
    open_edge_details,
    short_code: values.short_code,
    emr_provider: values.emr_provider,
    numberTypeFields: numberTypeFields,
    sms_provider_phone_id: smsProviderPhoneId
  };
  return AxiosCall.put(
    `/clinic-group/${group_id}/clinic/${clinic_id}/advance-edit`,
    clinicObject
  );
};

export const updateClinic = async (
  group_id: number | string,
  clinic_id: number | string,
  values: any
): Promise<ServiceErrorResponseType> => {
  const payment_plan_details = {
    is_enable: values.is_enable ? values.is_enable : false,
    total_installments: values.total_installments
      ? values.total_installments
      : null,
    min_instalment_amount: values.min_instalment_amount
      ? String(values.min_instalment_amount)
          .replace(/\$/g, '')
          .replace(/,/g, '')
      : null,
    total_weekly_installments: values.total_weekly_installments
      ? values.total_weekly_installments
      : null,
    total_bi_weekly_installments: values.total_bi_weekly_installments
      ? values.total_bi_weekly_installments
      : null
  };

  const clinicObject: Record<string, any> = {
    name: values.clinic_name ? values.clinic_name : '',
    description: values.description ? values.description : '',
    org_type_id: 1,
    email: values.clinic_email ? values.clinic_email : '',
    phone: values.clinic_phone ? values.clinic_phone : '',
    contact_name: values.primary_contact_name
      ? values.primary_contact_name
      : '',
    contact_phone: values.primary_contact_phone
      ? values.primary_contact_phone
      : '',
    contact_email: values.primary_contact_email
      ? values.primary_contact_email
      : '',
    address: values.address_line ? values.address_line : '',
    address_line_2: values.address_line_2 ? values.address_line_2 : '',
    city: values.city ? values.city : '',
    state: values.state ? values.state : '',
    zip: values.zip_postal_code ? values.zip_postal_code : '',
    country: values.country ? values.country : '',
    clinic_logo_url: values.clinic_logo_url ? values.clinic_logo_url : null,
    // sms_provider_phone: values.sms_provider_phone
    //   ? values.sms_provider_phone
    //   : null,
    // payment_provider: values.payment_provider ? values.payment_provider : null,
    // instamed_details: instamed_details,
    // open_edge_details,
    payment_plan_details,
    guarantor_login_note: values.guarantor_login_note,
    clinic_contact_text: values.clinic_contact_text,
    clinic_type: values.clinic_type,
    // receive_payment_notifications: Boolean(
    //   !values.receive_payment_notifications
    // ),
    // payment_receiver_email: values.payment_receiver_email,
    // payment_receiver_name: values.payment_receiver_name,
    auto_reply_sms_text: values.auto_reply_sms_text,
    should_forward_sms: Boolean(!values.should_forward_sms),
    forward_sms_phone: values.forward_sms_phone,
    after_hours_enabled: values.after_hours_enabled ? true : false,
    after_hours_start: values.after_hours_start || null,
    after_hours_end: values.after_hours_end || null,
    reports: values.reports,
    email_to_receive_report: values.email_to_receive_report,
    reply_to_email: values.reply_to_email,
    default_patient_email: values.default_patient_email
      ? String(values.default_patient_email).trim()
      : null,
    // short_code: values.short_code,
    billing_phone: values.billing_phone,
    practice_website: values.practice_website,
    convenience_fee: values.convenience_fee,
    cancel_copay_statement: Boolean(!values.cancel_copay_statement),
    send_status_emails: Boolean(!values.send_status_emails),
    pay_in_installments_guarantor_portal:
      values.pay_in_installments_guarantor_portal,
    clinic_provider_enable: values.clinic_provider_enable ? true : false,
    clinic_provider_npi: values.clinic_provider_npi
      ? values.clinic_provider_npi
      : '',
    ncpdp_provider_id: values.ncpdp_provider_id
      ? String(values.ncpdp_provider_id).trim()
      : '',
    is_patient_review_enabled:
      values.is_patient_review_enabled === true ? true : false,
    patient_review_url:
      values.is_patient_review_enabled === true
        ? values.patient_review_url
        : null,
    enable_insurance_reminder: values.enable_insurance_reminder ? true : false,
    insurance_reminder_duration: values.insurance_reminder_duration || null,
    insurance_reminder_duration_units:
      values.insurance_reminder_duration_units || null,
    max_no_of_reminders: values.max_no_of_reminders || null,
    location_number: values.location_number || null,
    insurance_provider: values.insurance_provider || null,
    tickets_report_email: values.tickets_report_email
      ? values.tickets_report_email
      : '',
    prior_auth_notification_emails: values.prior_auth_notification_emails
      ? values.prior_auth_notification_emails
      : '',
    personal_injury_practice: values.personal_injury_practice,
    cpt_code_generation: values.cpt_code_generation,
    enable_appointment_need_attention_emails: Boolean(
      values.enable_appointment_need_attention_emails
    ),
    appointment_need_attention_emails: values.appointment_need_attention_emails
      ? values.appointment_need_attention_emails
      : '',
    enable_appointment_escalation_sms: Boolean(
      values.enable_appointment_escalation_sms
    ),
    appointment_escalation_sms_phones: values.appointment_escalation_sms_phones
      ? values.appointment_escalation_sms_phones
      : '',
    enable_appointment_need_attention_sms: Boolean(
      values.enable_appointment_need_attention_sms
    ),
    appointment_need_attention_sms_phones: values.appointment_need_attention_sms_phones
      ? values.appointment_need_attention_sms_phones
      : '',
    hours_before_appt_edit_allowed:
      values.hours_before_appt_edit_allowed !== undefined &&
      values.hours_before_appt_edit_allowed !== null
        ? Number(values.hours_before_appt_edit_allowed)
        : null,
    hours_before_appt_delete_allowed:
      values.hours_before_appt_delete_allowed !== undefined &&
      values.hours_before_appt_delete_allowed !== null
        ? Number(values.hours_before_appt_delete_allowed)
        : null,
    business_start_time: values.business_start_time
      ? values.business_start_time.format
        ? values.business_start_time.format('HH:mm:ss')
        : values.business_start_time
      : null,
    business_end_time: values.business_end_time
      ? values.business_end_time.format
        ? values.business_end_time.format('HH:mm:ss')
        : values.business_end_time
      : null,
    max_family_slot_gap: values.max_family_slot_gap !== undefined && values.max_family_slot_gap !== null
      ? Number(values.max_family_slot_gap)
      : null,
    recording_disclosure_override:
      values.recording_disclosure_override === true
        ? true
        : values.recording_disclosure_override === false
        ? false
        : null,
    recording_disclosure_text:
      typeof values.recording_disclosure_text === 'string' &&
      values.recording_disclosure_text.trim()
        ? values.recording_disclosure_text.trim()
        : null,
  };
  if ('is_ccm_enabled' in values) {
    clinicObject.is_ccm_enabled = Boolean(values.is_ccm_enabled);
  }
  // Conditionally add properties to clinicObject
  if (!values.receive_payment_notifications && values.paymentsEnabled) {
    clinicObject.receive_payment_notifications = Boolean(
      !values.receive_payment_notifications
    );
  }
  if (values.payment_receiver_email && values.paymentsEnabled) {
    clinicObject.payment_receiver_email = values.payment_receiver_email;
  }

  if (values.payment_receiver_name && values.paymentsEnabled) {
    clinicObject.payment_receiver_name = values.payment_receiver_name;
  }
  if ('is_claim_tickets_cpt_codes_enabled' in values) {
    clinicObject.is_claim_tickets_cpt_codes_enabled = Boolean(
      values.is_claim_tickets_cpt_codes_enabled
    );
  }
  return AxiosCall.put(
    `/clinic-group/${group_id}/clinic/${clinic_id}`,
    clinicObject
  );
};

export const addClinicGroup = async (
  values: any
): Promise<ServiceSuccessResponseType<null>> => {
  const clinicObject = {
    group_name: values.clinic_group_name ? values.clinic_group_name : '',
    contact_name: values.primary_contact_name
      ? values.primary_contact_name
      : '',
    contact_phone: values.primary_contact_phone
      ? values.primary_contact_phone
      : '',
    contact_email: values.primary_contact_email
      ? values.primary_contact_email
      : '',
    address: values.address_line ? values.address_line : '',
    address_line_2: values.address_line_2 ? values.address_line_2 : '',
    city: values.city ? values.city : '',
    state: values.state ? values.state : '',
    zip: values.zip_postal_code ? values.zip_postal_code : '',
    country: values.country ? values.country : '',
    admin_first_name: values.admin_first_name ? values.admin_first_name : '',
    admin_last_name: values.admin_last_name ? values.admin_last_name : '',
    admin_phone: values.admin_phone ? values.admin_phone : '',
    admin_email: values.admin_email ? values.admin_email : '',
    emr_provider: values.emrprovider ? values.emrprovider : null,
    patients_shared: values.patients_shared,
    card_machines: values.card_machines,
    is_multi_column_mapping: values.is_multi_column_mapping,
    split_statement: values.split_statement,
    group_type: values.group_type,
    max_simultaneous_appointments:
      values.max_simultaneous_appointments != null
        ? Number(values.max_simultaneous_appointments)
        : 1,
    default_patient_email: values.default_patient_email
      ? String(values.default_patient_email).trim()
      : null
  };
  return AxiosCall.post(`/clinic-group`, clinicObject);
};

export const addClinicGroupPublic = async (
  values: any
): Promise<ServiceSuccessResponseType<null>> => {
  const clinicObject = {
    group_name: values.clinic_group_name ? values.clinic_group_name : '',
    contact_name: values.primary_contact_name
      ? values.primary_contact_name
      : '',
    contact_phone: values.primary_contact_phone
      ? values.primary_contact_phone
      : '',
    contact_email: values.primary_contact_email
      ? values.primary_contact_email
      : '',
    address: values.address_line ? values.address_line : '',
    address_line_2: values.address_line_2 ? values.address_line_2 : '',
    city: values.city ? values.city : '',
    state: values.state ? values.state : '',
    zip: values.zip_postal_code ? values.zip_postal_code : '',
    country: values.country ? values.country : '',
    admin_first_name: values.admin_first_name ? values.admin_first_name : '',
    admin_last_name: values.admin_last_name ? values.admin_last_name : '',
    admin_phone: values.admin_phone ? values.admin_phone : '',
    admin_email: values.admin_email ? values.admin_email : '',
    emr_provider: values.emrprovider ? values.emrprovider : null,
    patients_shared: values.patients_shared
  };
  return AxiosCall.post('/public/clinic-group', clinicObject);
};

export const updateClinicGroup = async (
  clinic_group_id: string | number,
  values: any
): Promise<ServiceErrorResponseType> => {
  const groupObject = {
    group_name: values.clinic_group_name ? values.clinic_group_name : '',
    contact_name: values.primary_contact_name
      ? values.primary_contact_name
      : '',
    ccm: values.ccm,
    ccm_clinic_id:
      values.ccm && values.ccm_clinic_id ? values.ccm_clinic_id : null,
    contact_phone: values.primary_contact_phone
      ? values.primary_contact_phone
      : '',
    contact_email: values.primary_contact_email
      ? values.primary_contact_email
      : '',
    address: values.address_line ? values.address_line : '',
    address_line_2: values.address_line_2 ? values.address_line_2 : '',
    city: values.city ? values.city : '',
    state: values.state ? values.state : '',
    zip: values.zip_postal_code ? values.zip_postal_code : '',
    country: values.country ? values.country : '',
    emr_provider: values.emrprovider ? values.emrprovider : null,
    patients_shared: values.patients_shared,
    billing_clinic_id: values.billing_clinic_id
      ? values.billing_clinic_id
      : null,
    split_statement: values.split_statement,
    is_multi_column_mapping: values.is_multi_column_mapping,
    max_simultaneous_appointments:
      values.max_simultaneous_appointments != null
        ? Number(values.max_simultaneous_appointments)
        : 1,
    default_patient_email:
      values.default_patient_email !== undefined
        ? values.default_patient_email
          ? String(values.default_patient_email).trim()
          : null
        : undefined,
    send_frequent_notification_guarantor:
      values.send_frequent_notification_guarantor,
    skip_notification_guarantor_duration:
      values.skip_notification_guarantor_duration,
    skip_notification_guarantor_duration_unit:
      values.skip_notification_guarantor_duration_unit,
    // update the enanle keys
    patients: values.patients,
    enable_add_patients: values.enable_add_patients,
    enable_edit_patients: values.enable_edit_patients,
    send_patients_to_emr: values.send_patients_to_emr,
    appointments: values.appointments,
    statements: values.statements,
    payments: values.payments,
    messages: values.messages,
    patient_recalls: values.patient_recalls,
    card_machines: values.card_machines,
    consolidated_group_billing: values.consolidated_group_billing,
    show_only_billing_practice: values.consolidated_group_billing
      ? values.show_only_billing_practice
      : false,
    eligibility_verification: values.eligibility_verification,
    prior_authorizations_tickets: values.prior_authorizations_tickets,
    claims_tickets: values.claims_tickets,
    patient_portal: values.patient_portal,
    is_claim_tickets_cpt_codes_enabled:
      values.is_claim_tickets_cpt_codes_enabled,
    patient_forms: values.patient_forms,
    claims: values.claims,
    epic_base_url: values.epic_base_url,
    epic_client_id: values.epic_client_id,
    smart_coder: values.smart_coder,
    referrals_tickets: values.referrals_tickets,
    is_doctor_notes_analysis_enabled: values.is_doctor_notes_analysis_enabled,
    auto_create_prior_auth_on_appointment_import:
      values.auto_create_prior_auth_on_appointment_import
  };
  return AxiosCall.put(`/clinic-group/${clinic_group_id}`, groupObject);
};

export const deleteGroup = async (
  group_id: number | string
): Promise<ServiceErrorResponseType> => {
  return AxiosCall.delete(`/clinic-group/${group_id}`);
};

export const addUserService = async (
  group_id: any,
  values: any
): Promise<ServiceSuccessResponseType<null>> => {
  const userObject = {
    first_name: values.first_name ? values.first_name : '',
    last_name: values.last_name ? values.last_name : '',
    email: values.email ? values.email : '',
    phone: values.phone ? values.phone : '',
    job_title_id: values.job_title_id ? values.job_title_id : '',
    roles: values.roles.length > 0 ? values.roles : [],
    clinics: values.clinics.length > 0 ? values.clinics : []
  };
  return AxiosCall.post(`/group/${group_id}/user`, userObject);
};
// Get Details of a clinic via clinic ID
export const getClinicDetails = async (
  params: ClinicBaseParams
): Promise<ServiceSuccessResponseType<ClinicModelMapper>> => {
  let queryParams = '';
  if (params?.fetch_last_imported_month) {
    queryParams += `fetch_last_imported_month=${params.fetch_last_imported_month}`;
  }
  return AxiosCall.get(
    `/clinic-group/${params.groupId}/clinic/${params.clinicId}/?${queryParams}`,
    params.source
  );
};

export const getClinicDetailsFromShortCode = async (
  shortCode: string
): Promise<ServiceSuccessResponseType<ClinicModelMapper>> => {
  return AxiosCall.get(`/clinic-group/clinic/${shortCode}`);
};

export const getGroupUser = async (params: UserBaseParams): Promise<any> => {
  return AxiosCall.get(`/group/${params.groupId}/user/${params.userId}`);
};

export const updateGroupUser = async (
  clinicGroupId: string | number,
  userId: string | number,
  values: any
): Promise<any> => {
  const userObject = {
    first_name: values.first_name ? values.first_name : '',
    last_name: values.last_name ? values.last_name : '',
    email: values.email ? values.email : '',
    phone: values.phone ? values.phone : '',
    job_title_id: values.job_title_id ? values.job_title_id : '',
    roles: values.roles.length > 0 ? values.roles : [],
    clinics: values.clinics.length > 0 ? values.clinics : []
  };
  return AxiosCall.put(`/group/${clinicGroupId}/user/${userId}`, userObject);
};

export const deleteUser = async (
  clinicGroupId: string | number,
  userId: string | number
): Promise<any> => {
  return AxiosCall.delete(`/group/${clinicGroupId}/user/${userId}`);
};

export const unlockUser = async (
  clinicGroupId: string | number,
  userId: string | number
): Promise<any> => {
  return AxiosCall.put(`/group/${clinicGroupId}/user/${userId}/unlockUser`, {});
};

export const createClinicGroup = async (
  values: any
): Promise<ServiceSuccessResponseType<null>> => {
  const clinicObject = {
    group_name: values.clinic_group_name ? values.clinic_group_name : '',
    contact_name: values.primary_contact_name
      ? values.primary_contact_name
      : '',
    contact_phone: values.primary_contact_phone
      ? values.primary_contact_phone
      : '',
    contact_email: values.primary_contact_email
      ? values.primary_contact_email
      : '',
    address: values.address_line ? values.address_line : '',
    address_line_2: values.address_line_2 ? values.address_line_2 : '',
    city: values.city ? values.city : '',
    state: values.state ? values.state : '',
    zip: values.zip_postal_code ? values.zip_postal_code : '',
    country: values.country ? values.country : '',
    admin_first_name: values.admin_first_name ? values.admin_first_name : '',
    admin_last_name: values.admin_last_name ? values.admin_last_name : '',
    admin_phone: values.admin_phone ? values.admin_phone : '',
    admin_email: values.admin_email ? values.admin_email : ''
  };
  return AxiosCall.post(`/public/clinic-group`, clinicObject);
};

export const resendInvite = async (params: UserBaseParams): Promise<any> => {
  return AxiosCall.put(
    `/group/${params.groupId}/user/${params.userId}/resend-invite`,
    {}
  );
};

export const inviteUserToClinicGroup = async (
  clinicGroupId: string | number,
  values: any
): Promise<any> => {
  const userObject = {
    user_id: values.user_id,
    roles: values.roles.length > 0 ? values.roles : [],
    clinics: values.clinics.length > 0 ? values.clinics : []
  };
  return AxiosCall.post(`/group/${clinicGroupId}/user/invite`, userObject);
};

export const validateClinicShortCode = async (payload: {
  clinic_id?: string | number;
  short_code: string;
}): Promise<any> => {
  return AxiosCall.post(`/clinic-group/clinic/short-code/validate`, payload);
};

export const checkPaymentPlanExist = async (payload: {
  clinic_id: string | number;
  group_id: string;
}): Promise<any> => {
  const url = `/clinic-group/${payload.group_id}/clinic/${payload.clinic_id}/active-payment-plan-config`;

  return AxiosCall.get(url);
};

export const saveCardMachineDetails = async (payload: {
  clinic_group_id: string | number;
  machine_name: string;
  serial_number: string;
  terminal_id: string;
  clinic_id: string | number;
}): Promise<any> => {
  const url = `/clinic-group/${payload.clinic_group_id}/card-machine`;

  return AxiosCall.post(url, {
    machine_name: payload.machine_name,
    serial_number: payload.serial_number,
    terminal_id: payload.terminal_id,
    clinic_id: payload.clinic_id
  });
};

export const updateCardMachineDetails = async (payload: {
  clinic_group_id: string | number;
  machine_id: string | number;
  machine_name: string;
  serial_number: string;
  terminal_id: string;
  clinic_id: string | number;
}): Promise<any> => {
  const url = `/clinic-group/${payload.clinic_group_id}/card-machine/${payload.machine_id}`;

  return AxiosCall.put(url, {
    machine_name: payload.machine_name,
    serial_number: payload.serial_number,
    terminal_id: payload.terminal_id,
    clinic_id: payload.clinic_id
  });
};

export const fetchCardMachineDetails = async (payload: {
  clinic_group_id: string | number;
  clinic_id: string | number;
}): Promise<any> => {
  const url = `/clinic-group/${payload.clinic_group_id}/card-machine?clinic_id=${payload.clinic_id}`;

  return AxiosCall.get(url);
};

export const activateCardMachine = async (payload: {
  clinic_group_id: string | number;
  machine_id: string | number;
}): Promise<any> => {
  const url = `/clinic-group/${payload.clinic_group_id}/card-machine/${payload.machine_id}/activate`;

  return AxiosCall.put(url, {});
};

export const deactivateCardMachine = async (payload: {
  clinic_group_id: string | number;
  machine_id: string | number;
}): Promise<any> => {
  const url = `/clinic-group/${payload.clinic_group_id}/card-machine/${payload.machine_id}/deactivate`;

  return AxiosCall.put(url, {});
};

export const checkUnPostedPaymentsExists = async (payload: {
  clinic_group_id: string | number;
  clinic_id: string | number;
}): Promise<any> => {
  const url = `/clinic-group/${payload.clinic_group_id}/clinic/${payload.clinic_id}/un-posted-payments`;

  return AxiosCall.get(url);
};
export const getClinicUsersList = async (
  clinic_group_id: string | number,
  clinic_id: string | number,
  params?: {
    object?: string;
  }
): Promise<ServiceSuccessResponseType<Array<UserModelMapper>>> => {
  const queryParams = serializeQueryParams(params);
  const url = `/clinic-group/${clinic_group_id}/clinic/${clinic_id}/clinic-users${
    queryParams ? `?${queryParams}` : ''
  }`;
  return AxiosCall.get(url);
};

export const deleteCardMachineApi = async (payload: {
  clinic_group_id: string | number;
  machine_id: string | number;
}): Promise<any> => {
  const url = `/clinic-group/${payload.clinic_group_id}/card-machine/${payload.machine_id}`;

  return AxiosCall.delete(url);
};

export const verifyCardMachine = async (
  clinic_group_id: string | number,
  values: any,
  fromEdit: boolean
): Promise<any> => {
  const payload: any = {
    clinic_id: values.clinic_id,
    terminal_id: values.terminal_id,
    machine_name: values.machine_name,
    reference_id: values.reference_id
  };
  if (fromEdit) {
    payload.machine_id = values.machine_id;
  }
  const url = `/clinic-group/${clinic_group_id}/card-machine/verify`;

  return AxiosCall.post(url, payload, values.cancelToken);
};

export const allHealthCareProvidersOfClinicGroup = async (
  group_id: number | string,
  search_text = '',
  params?: {
    clinic_id?: number;
  }
): Promise<ServiceSuccessResponseType<ArrayResponse<ArrayRows>>> => {
  let queryParams = '';
  if (params) {
    queryParams = serializeQueryParams(params);
  }
  if (search_text) {
    const searchTextParam = `search_text=${encodeURIComponent(search_text)}`;
    if (queryParams) queryParams += `&${searchTextParam}`;
    else queryParams = searchTextParam;
  }
  return AxiosCall.get(
    `/clinic-group/${group_id}/insurance-verification/provider/all${
      queryParams ? `?${queryParams}` : ''
    }`
  );
};

export const importProvidersFromFile = async ({
  clinic_group_id,
  data
}: {
  clinic_group_id: number | null;
  data: any;
}): Promise<any> => {
  return AxiosCall.post(
    `/clinic-group/${clinic_group_id}/insurance-verification/provider/import`,
    data
  );
};

export const deleteHealthCareProvider = async (
  clinicGroupId: string | number,
  providerId: string | number
): Promise<any> => {
  return AxiosCall.delete(
    `/clinic-group/${clinicGroupId}/insurance-verification/provider/${providerId}`
  );
};

export const saveHealthCareProvider = async (
  clinicGroupId: string | number,
  params: any
): Promise<any> => {
  return AxiosCall.post(
    `/clinic-group/${clinicGroupId}/insurance-verification/provider`,
    params
  );
};

export const updateHealthCareProvider = async (
  clinicGroupId: string | number,
  providerId: string | number,
  params: any
): Promise<any> => {
  return AxiosCall.put(
    `/clinic-group/${clinicGroupId}/insurance-verification/provider/${providerId}`,
    params
  );
};

export const getHealthCareProviderById = async (
  clinicGroupId: string | number,
  providerId: string | number
): Promise<any> => {
  return AxiosCall.get(
    `/clinic-group/${clinicGroupId}/insurance-verification/provider/${providerId}`
  );
};

export const getClinicGroupPayersList = async (
  group_id: number | string,
  search_text = '',
  params?: {
    limit?: number;
    offset?: number;
  }
): Promise<any> => {
  let queryParams = '';
  if (params) {
    queryParams = serializeQueryParams(params);
  }
  if (search_text) {
    const searchTextParam = `search_text=${encodeURIComponent(search_text)}`;
    if (queryParams) queryParams += `&${searchTextParam}`;
    else queryParams = searchTextParam;
  }
  return AxiosCall.get(
    `/clinic-group/${group_id}/insurance-verification/payers/all${
      queryParams ? `?${queryParams}` : ''
    }`
  );
};

export const getGroupLevelEnabledModules = async (): Promise<any> => {
  return AxiosCall.get(`/reference-data/system-modules`);
};

export const getAppointmentSlotTimings = ({
  clinic_group_id,
  clinic_id,
  params
}: {
  clinic_group_id: number;
  clinic_id: number;
  params?: Record<string, any>;
}) => {
  let queryParams = '';
  if (params) {
    queryParams = serializeQueryParams(params);
  }
  return AxiosCall.get(
    `/clinic-group/${clinic_group_id}/clinic/${clinic_id}/work-timings?${queryParams}`
  );
};

export const createAppointmentSlotTimings = ({
  clinic_group_id,
  clinic_id,
  payload
}: {
  clinic_group_id: number;
  clinic_id: number;
  payload: any;
}) => {
  return AxiosCall.post(
    `/clinic-group/${clinic_group_id}/clinic/${clinic_id}/work-timings`,
    payload
  );
};

export const updateAppointmentSlotTimings = ({
  clinic_group_id,
  clinic_id,
  payload
}: {
  clinic_group_id: number;
  clinic_id: number;
  payload: any;
}) => {
  return AxiosCall.put(
    `/clinic-group/${clinic_group_id}/clinic/${clinic_id}/work-timings`,
    payload
  );
};

export const importAppointmentSlotsFromFile = async ({
  clinic_group_id,
  clinic_id,
  data
}: {
  clinic_group_id: number | null;
  clinic_id: number | null;
  data: any;
}): Promise<any> => {
  return AxiosCall.post(
    `/clinic-group/${clinic_group_id}/clinic/${clinic_id}/appointment-slots/import`,
    data
  );
};

export const updateUserDetailsFromSuperAdminPortal = async (
  userId: number,
  values: any
): Promise<any> => {
  const userObject = {
    first_name: values.first_name ? values.first_name : '',
    last_name: values.last_name ? values.last_name : '',
    email: values.email ? values.email : '',
    phone: values.phone ? values.phone : '',
    job_title_id: values.job_title_id ? values.job_title_id : null
  };
  return AxiosCall.put(`/admin/system/user/${userId}`, userObject);
};

export const fetchProvidersForAppointmentByClinicId = (
  clinicGroupId: number,
  clinicId: number
): Promise<ServiceSuccessResponseType<ArrayRows>> => {
  return AxiosCall.get(
    `/clinic-group/${clinicGroupId}/clinic/${clinicId}/providers`
  );
};

export const fetchAllProvidersForClinic = (
  clinicGroupId: number,
  clinicId: number
): Promise<ServiceSuccessResponseType<ProviderListResponse>> => {
  return AxiosCall.get(
    `/clinic-group/${clinicGroupId}/clinic/${clinicId}/providers/all`
  );
};

export const fetchProvidersByAppointmentSlotId = (
  clinicGroupId: number,
  clinicId: number,
  appointmentSlotId: number
): Promise<ServiceSuccessResponseType<ArrayRows>> => {
  return AxiosCall.get(
    `/clinic-group/${clinicGroupId}/clinic/${clinicId}/appointment-slot/${appointmentSlotId}/providers`
  );
};

export const getProviderImportTemplateFile = (): any => {
  return AxiosCall.getFile({url: 'file/template/health-care-providers'});
};

export const getAppointmentSlotsImportTemplateFile = (): any => {
  return AxiosCall.getFile({url: 'file/template/practice-appointment-slots'});
};
